import {Action, createReducer, on} from '@ngrx/store';
import {PatientStore} from '../../models/store/user/patient';

import {editPatient, loadPatients, paginatePatients, removeAllPatients, removePatients} from 'src/actions/user/patient.action';

export const initialState: PatientStore = {
  fetching: false,
  data: {
    patients: [],
    totalDocuments: 0
  }
};

const patientsReducer = createReducer(initialState,
  on(loadPatients, (state, {payload, totalDocuments}) => (
    {
      ...state,
      data: {
        ...state.data,
        patients: [
          ...state.data.patients,
          ...payload.filter(p => !state.data.patients.find(ds => ds._id === p._id))
        ],
        totalDocuments
      }
    })
  ),
  on(editPatient, (state, payload: any) => (
    {
      ...state,
      data: {
        ...state.data,
        patients: state.data.patients.map(
          data => {
            if (data._id === payload._id) {
              return {
                ...data,
                ...payload
              };
            }

            return data;
          }
        )
      }
    })
  ),
  on(removePatients, (state, {payload}) => (
    {
      ...state,
      data: {
        ...state.data,
        patients: state.data.patients
          .filter(d => !payload.includes(String(d._master))),
        totalDocuments: state.data.totalDocuments - 1,
      }
    })
  ),
  on(removeAllPatients, (state) => (
      {
        ...state,
        data: {
          ...state.data,
          patients: [],
          totalDocuments: 0
        }
      }
    )
  ),
  on(paginatePatients, (state) => state)
);

export function reducer(state: PatientStore, action: Action): any {
  return patientsReducer(state, action);
}
